<template>
  <div id="app">

    <EventBrowser :selected-event-types="selectedEventTypes" :selected-tags="selectedTags" :domain="domain"/>
  </div>
</template>

<script>
/*eslint no-undef: 0*/
/* eslint-disable */
// eslint-disable-next-line

import EventBrowser from './components/EventBrowser.vue';


export default {
  name: 'App',
  el: '#app',
  props: {
    domain: {
      type: String,
      default: 'dgm.inventum.de'
    },
    selectedEventTypes: {
      type: Array,
      default: () => []
    },
    selectedTags: {
      type: Array,
      default: () => []
    }
  },
  components: {

    EventBrowser
  }
}
</script>

<style lang="scss">

</style>
